export default __webpack_public_path__ + "static/media/CNo.77-6.3eb74704.jpg";